/*eslint no-unused-vars:0 */
import $ from 'jquery';
import 'slick-carousel/slick/slick.min';
import Plyr from 'plyr';
// import 'plyr/dist/plyr.css';
import fitText from '../util/fittext';

export default {
  init() {
    // make the appointment modal work
    this.appointmentModal();
    this.initCarousel();
    if (document.documentElement.clientWidth > 599) {
      this.gridSizeAdjustments();
    }
    this.headerPosition();
    this.headerTheme();
    if (document.querySelector('#player')) {
      this.initVideoSlider();
    }
    if (document.querySelector('body').classList.contains('template-shop')) {
      let swagTile = document.querySelector('.cat-glaudi-swag .card');
      if (swagTile) {
        swagTile.setAttribute(
          'style',
          'background-image: url(https://glaudicollection.com/wp-content/uploads/2018/09/glaudi-swag.jpg)'
        );
      }
    }


    try {
      let titles = document.querySelectorAll('.c-collection__grid .card-footer .title');
      Array.prototype.forEach.call(titles, title => {
        fitText(title, 1, { minFontSize: '15px', maxFontSize: '40px' });
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  },
  initCarousel() {
    const productCarouselConfig = {
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      mobileFirst: false,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 599,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
      dots: false,
      speed: 250,
      lazyLoad: 'ondemand',
      autoplay: true,
      autoplaySpeed: 2000,
      arrow: true,
    };

    $('.c-featured-products').slick(productCarouselConfig);
  },
  gridSizeAdjustments() {
    const columnGrids = document.querySelectorAll('.c-collection__grid');

    for (let i = 0; i < columnGrids.length; i++) {
      let grid = columnGrids[i];
      let panels = grid.querySelectorAll('.c-collection__grid__panel');
      switch (panels.length) {
        case 2:
          grid.style.setProperty('--columns-template', 'repeat(2, 1fr)');
          grid.style.setProperty('--rows-template', '1fr');
          Array.prototype.forEach.call(panels, function (panel) {
            panel.style.setProperty('grid-row', '1 / span 1');
          });
          break;
        case 3:
          grid.style.setProperty('--columns-template', 'repeat(2, 1fr)');
          break;
        case 4:
          panels[panels.length - 1].style.setProperty('grid-row', '1 / span 3');
          break;
        default:
      }
    }

  },
  appointmentModal() {
    let body = document.querySelector('body');
    let appointmentModal = document.getElementById('appointment_modal');

    if (body.classList.contains('template-about') && appointmentModal) {
      const appointmentForm = document.querySelector('#appointment-acf-form');
      const titleLabel = document.querySelector(
        '.acf-label label[for="acf-_post_title"]'
      );
      if (appointmentForm && titleLabel) {
        titleLabel.innerText = 'Your name';
      }
      // initialize modal
      $('.make-appointment').magnificPopup({
        type: 'inline',
      });
    }
  },
  headerPosition() {
    const intro = document.querySelector('.l-intro');
    const header = document.querySelector('#header');
    if (intro) {
      header.style.setProperty('--header-position', 'absolute');
    }
  },
  headerTheme() {
    // --header-white-first-row: rgba(255, 255, 255, 0.9);
    // --header-white-second-row: rgba(255, 255, 255, 0.7);
    // --header-pink-first-row: #fbd6e2;
    // --header-pink-second-row: #fde5ed;
    const intro = document.querySelector('.l-intro');
    const firstRow = document.querySelector('#header .navbar .first-row');
    const secondRow = document.querySelector('#header .navbar .second-row');

    if (intro) {
      firstRow.style.setProperty(
        'background-color',
        'var(--header-white-first-row)'
      );
      // secondRow.style.setProperty(
      //   'background-color',
      //   'var(--header-white-second-row)'
      // );
    } else {
      firstRow.style.setProperty(
        'background-color',
        'var(--header-pink-first-row)'
      );
      secondRow.style.setProperty(
        'background-color',
        'var(--header-pink-second-row)'
      );
    }
  },
  initVideoSlider() {
    const player = new Plyr('#slider-intro-video', {
      muted: true,
      autoplay: true,
      controls: x => false,
      loop: {
        active: true,
      },
    });

    const playerIframe = document.querySelector('#player iframe');
    const playerHeight = window.innerWidth * 0.56;
    playerIframe.style.height = playerHeight + 'px';
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    window.addEventListener('load', e => {
      let resizeDispatched = window.dispatchEvent(new Event('resize'));
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js